module.exports = __webpack_public_path__ + "assets/icons/ic_CO2_auto_zero.svg";